const styles = theme => ({
  base: theme.loginBase,
})

export default styles
